<div class="dotted-loader" [hidden]="resultsPageGrid && resultsPageGrid.filtersForm"></div>
<form *ngIf="resultsPageGrid && resultsPageGrid.filtersForm" #form="ngForm" [formGroup]="resultsPageGrid.filtersForm">
  <div class="row mb-4">
    <div class="col-12 col-md-3 padding-cha-r">
      <label> From </label>
      <input
        autocomplete="off"
        placeholder="From"
        type="text"
        bsDatepicker
        formControlName="dateFrom"
        [bsConfig]="{ containerClass: 'theme-dark-blue' }"
        tabindex="3"
      />
    </div>
    <div class="col-12 col-md-3 padding-cha-l">
      <label> To </label>
      <input
        autocomplete="off"
        placeholder="To"
        type="text"
        bsDatepicker
        formControlName="dateTo"
        [minDate]="setFromDateAsMinDate"
        [bsConfig]="{ containerClass: 'theme-dark-blue' }"
        tabindex="4"
      />
    </div>
  </div>
</form>

<div class="grid-container">
  <div class="loader" *ngIf="resultsPageGrid?.refreshDataInProgress"></div>
  <div [hidden]="resultsPageGrid?.refreshDataInProgress">
    <p *ngIf="!resultsPageGrid?.refreshDataInProgress && !resultsPageGrid?.total">No Records Found.</p>
    <div *ngIf="resultsPageGrid && resultsPageGrid?.total" class="research-grid-container stripe-table">
      <table mat-table [dataSource]="resultsPageGrid.dataSource">
        <!-- matSort (matSortChange)="resultsPageGrid.onSortChange($event)" -->
        <ng-container *ngFor="let col of resultsPageGrid.displayedColumns" [matColumnDef]="col">
          <!-- [mat-sort-header]="col"  -->
          <th mat-header-cell *matHeaderCellDef [ngClass]="col === 'date' ? 'text-center' : 'text-end'">
            {{ getColumn(col) }}
          </th>
          <td mat-cell *matCellDef="let dataItem">
            <ng-container [ngSwitch]="col">
              <div *ngSwitchCase="'date'" class="text-center text-nowrap">{{ dataItem.date | mdate }}</div>
              <ng-container *ngSwitchDefault>
                <ng-container *ngIf="gridColumns">
                  <div *ngIf="formatColumn(col, 'money')" class="text-end text-nowrap">
                    {{ dataItem[col] | money }}
                  </div>
                  <div *ngIf="formatColumn(col, 'number')" class="text-end text-nowrap">
                    {{ dataItem[col] | number }}
                  </div>

                  <div *ngIf="formatColumn(col, 'numberAbbr')" class="text-end text-nowrapt">
                    {{ dataItem[col] | numberAbbr }}
                  </div>
                  <div *ngIf="formatColumn(col, 'decimalRemove')" class="text-end text-nowrap">
                    {{ dataItem[col] | decimalRemove }}
                  </div>
                </ng-container>
              </ng-container>
            </ng-container>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="resultsPageGrid.displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: resultsPageGrid.displayedColumns"></tr>
        <tr *matNoDataRow>
          <td [attr.colspan]="resultsPageGrid.displayedColumns.length">
            <div [hidden]="!gridInProgress" class="loader">loader</div>
          </td>
        </tr>
      </table>
      <mat-paginator
        [length]="resultsPageGrid?.total"
        [pageSize]="resultsPageGrid?.pageSize"
        [pageSizeOptions]="[5, 10, 25, 100]"
        aria-label="Select page"
      >
      </mat-paginator>
    </div>
  </div>
</div>
